import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import * as intlTelInput from 'intl-tel-input';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'intl-phone-code-field',
  templateUrl: './intl-phone-code-field.component.html'
})
export class IntlPhoneCodeFieldComponent implements AfterViewInit {
  @Output() onIntlCodeChanged = new EventEmitter<{ dialCode: string, phoneNumber: string, valid: boolean }>();
  @ViewChild('flagField', { static: true }) flagField: ElementRef;
  private iti: intlTelInput.Plugin;

  public rawValue = '';
  public valid = false;

  private intlCodeInputSubscription: any;
  private intlCodeDropdownSubscription: any;

  constructor() { }

  ngAfterViewInit() {
    this.iti = intlTelInput(this.flagField.nativeElement, {
      preferredCountries: ['ie', 'gb'],
    });

    // wait for pause before emitting value
    this.intlCodeInputSubscription = fromEvent<any>(this.flagField.nativeElement, 'keyup').pipe(
      map(event => event.target.value),
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(() => {
      this.emitValue();
    });

    // emit everytime the dropdown is changed
    this.intlCodeDropdownSubscription = fromEvent<any>(this.flagField.nativeElement, 'countrychange').subscribe(() => {
      this.emitValue();
    });
  }

  ngOnDestroy() {
    if (this.intlCodeInputSubscription) {
      this.intlCodeInputSubscription.unsubscribe();
    }
    if (this.intlCodeDropdownSubscription) {
      this.intlCodeDropdownSubscription.unsubscribe();
    }
  }

  private emitValue() {
    var isValid = this.iti.isValidNumber();
    this.valid = isValid;

    if (isValid) {
      this.onIntlCodeChanged.emit(this.separatePhoneNumber());
    } else {
      this.onIntlCodeChanged.emit({
        dialCode: '+' + this.iti.getSelectedCountryData().dialCode,
        phoneNumber: this.rawValue,
        valid: false,
      });
    }
  }

  private separatePhoneNumber() {
    let dialCode = this.iti.getSelectedCountryData().dialCode;
    let phoneNumber = this.iti.getNumber()

    let dialCodeFromNumber = phoneNumber.substring(0, dialCode.length + 1);
    let phoneNumberWithoutDialCode = '0' + phoneNumber.substring(dialCode.length + 1);
    return {
      dialCode: dialCodeFromNumber,
      phoneNumber: phoneNumberWithoutDialCode,
      valid: true
    };
  }

}
